<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">{{$t('dashboard')}}</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/new-reimbursement/history-reimbursement"
                >{{$t('paidReimburst')}}</router-link
              ></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="6"></b-col>
      </b-row>
    </b-card>
    <div v-if="isLoading">
      <b-card>
      <div class="text-center" style="height: 15vh; margin: 10% auto;">
        <b-spinner type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
      </div>
      </b-card>
    </div>
    <div v-else class="mb-3">
      <b-card class="">
        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('noRequest')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.noRequest !== null ? detail.noRequest : '-' }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('employee')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.requestedBy !== null ? detail.requestedBy.name : '-' }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('amount')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ dataAccount.account.currency }}  {{ detail.amount !== null ? formatPrice(detail.amount) : '-' }}</b-col>
        </b-row>

         <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('receiptDate')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.receiptDate ? detail.receiptDate : '-' }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('categories')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{
            detail.reimburseCategory !== null ? detail.reimburseCategory.categoryName : '-'
          }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('description')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.note !== null ? detail.note : '-' }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('reqDate')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{
            detail.createdAt !== null ? getDateTime(detail.createdAt) : '-'
          }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('approvedBy')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.approvedBy !== null ? detail.approvedBy : '-' }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('approvedTime')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{
            detail.approvedTime !== null ? getDateTime(detail.approvedTime) : '-'
          }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('paidBy')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.paidBy !== null ? detail.paidBy : '-' }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t("paidTime")}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.paidTime !== null ? getDateTime(detail.paidTime) : '-' }}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="2">
            <label for="" class="labels">{{$t('paidNote')}}</label>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">{{ detail.paidNote !== null ? detail.paidNote : '-' }}</b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col md="12">
            <h4>{{$t('photo')}}</h4>
            <b-row v-if="detail.reimbursePhotoList.length === 0">
              <b-col md="3">
                <p class="text-secondary text-center border p-5"><i>No Photo Submitted</i></p>
              </b-col>
            </b-row>
            <viewer :images="detail.reimbursePhotoList" v-else>
              <b-row>
                <b-col md="3" v-for="(src, index) in detail.reimbursePhotoList" :key="index">
                  <p class="text-secondary text-center border p-5" v-if="src === null">
                    <i>No Photo Submitted</i>
                  </p>
                  <b-img v-else :src="src" class="img-responsive" width="300" height="200" />
                </b-col>
              </b-row>
            </viewer>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="mt-1 mb-5">
      <b-button @click="goBack()" class="mt-4" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left" /> {{$t('back')}}</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataAccount: this.$store.getters['account/accountData'],
      isLoading: false,
      apiUrl: {
        reimbursement: window.AppConfig.apiUrl + 'reimbursement',
      },
      detail: {
        account: null,
        amount: null,
        approvedBy: null,
        approvedTime: null,
        cancelBy: null,
        cancelTime: null,
        createdAt: null,
        noRequest: null,
        note: null,
        options: null,
        paidBy: null,
        paidNote: null,
        paidRefNumber: null,
        paidTime: null,
        reimburseCategory: null,
        reimburseHistory: null,
        reimbursePhoto: null,
        reimburseType: null,
        rejectedBy: null,
        rejectedTime: null,
        requestedBy: null,
        status: null,
        updatedAt: null,
        uuid: null,
        reimbursePhotoList: [],
        reimburseHistoryList: [],
      },
    };
  },

  mounted() {
    this.fetchDetailPaidReimburs();
  },

  methods: {
    fetchDetailPaidReimburs() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.reimbursement + '/' + this.$route.params.uuid)
        .then((resp) => {
          this.detail = resp.data;
          this.detail.noRequest = resp.data.noRequest;
          this.detail.amount = resp.data.amount;
          this.detail.approvedBy = resp.data.approvedBy;
          this.detail.approvedTime = resp.data.approvedTime;
          this.detail.cancelBy = resp.data.cancelBy;
          this.detail.cancelTime = resp.data.cancelTime;
          this.detail.createdAt = resp.data.createdAt;
          this.detail.note = resp.data.note;
          this.detail.paidBy = resp.data.paidBy;
          this.detail.paidNote = resp.data.paidNote;
          this.detail.paidTime = resp.data.paidTime;
          this.detail.reimburseCategory = resp.data.reimburseCategory;
          this.detail.reimburseHistory = resp.data.reimburseHistory;
          this.detail.rejectedBy = resp.data.rejectedBy;
          this.detail.rejectedTime = resp.data.rejectedTime;
          this.detail.requestedBy = resp.data.requestedBy;
          this.detail.status = resp.data.status;
          this.detail.reimbursePhotoList = [];
          if (resp.data.reimbursePhoto !== null) {
            resp.data.reimbursePhoto.forEach((data) => {
              this.detail.reimbursePhotoList.push(data.url);
            });
          }
          this.detail.reimburseHistoryList = [];
          if (resp.data.reimburseHistory !==null){
            resp.data.reimburseHistory.forEach((data)=>{
              this.detail.reimburseHistoryList.push(data)
            })
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
          this.isLoading = false;
        });
    },

    goBack() {
      window.goBack(this);
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm A');
      } else {
        return '-';
      }
    },
    getStatusColor(val) {
      switch (val) {
        case 'Approved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Requested':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Rejected':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Paid':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>
